import { Component, Inject, OnInit, HostListener, Input, SimpleChange, ViewChild, ViewChildren, QueryList, ViewContainerRef, TemplateRef} from '@angular/core';;
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppSettingService } from '../app.service';
import { TerritoryCardService, ITerritoryCard, ETerritoryCardType } from './territory-card.service';
import { TerritoryCardComponent } from './territory-card.component';
import Swal from 'sweetalert2';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-territory-card-instances',
	templateUrl: "./territory-card-instances.component.html",
	styleUrls: ['./territory-card.scss'],
	standalone: false
})
export class TerritoryCardInstancesComponent implements OnInit {
	@Input() normalizedData: ITerritoryCard;
	@Input() targetType: string;
	@Input() clicked: boolean = false;

	constructor(private dialog: MatDialog) {}

	mobileView: boolean = AppSettingService.widgetMobile();

	@HostListener('window:resize', ['$event']) onResize(e: any) {
		this.mobileView = AppSettingService.widgetMobile();
	}

	ngOnInit(): void {
		if (this.targetType !== 'learnMore' && this.targetType !== 'map' && this.targetType !== 'journey' && this.targetType !== 'select') {
			throw "Target Type should be either learnMore, map, journey, select. The given one is " + this.targetType;
		}
		if (!this.normalizedData.hasMany || (this.normalizedData?.ObjectInstances?.length??0) == 0) {
			throw "This function is for object with many instances. ObjectInstances should not be empty";
		}
	}

	instancePopup: any = null;

	select() {
		if (this.instancePopup != null) {
			return;
		}
		this.instancePopup = this.dialog.open(
			TerritoryCardInstancesDialog,
			{
				maxWidth: '1280px',
				width: '95%',
				disableClose: false,
				autoFocus: true,
				panelClass: 'jmDialog',
				data: {
					normalizedData: this.normalizedData,
					targetType: this.targetType
				}
			}
		);

		this.instancePopup.afterClosed().subscribe({
			next: (resulte: any) => {
				this.instancePopup = null;
			}
		});
	}

	ngOnChanges(changes: any) {
		if (changes['clicked']) {
			let clicked = changes['clicked'];
			if ((clicked.previousValue ?? null) != null && (clicked.currentValue ?? null) != null  && clicked.currentValue != clicked.previousValue) {
				this.select();
			}
		}
	}
}



@Component({
	selector: "app-territory-card-instancese-dialog",
	templateUrl: "./territory-card-instances.dialog.html",
	styleUrls: ['./territory-card.scss'],
	standalone: false
})
export class TerritoryCardInstancesDialog {
	tCardType = ETerritoryCardType;
	normalizedData: ITerritoryCard;
	targetType: string = "";
	ancestorIconBackground: string = "";
	ancestorIconForeground: string = "";
	showBack: boolean = false;
	oneCluster: boolean = false;
	pages: any = [];

	constructor(
		private tcs: TerritoryCardService,
		public dialogRef: MatDialogRef<TerritoryCardInstancesDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private router: Router
	) {
		this.normalizedData = data.normalizedData;
		this.targetType = data.targetType;
	}
	
	showMinimize: boolean = AppSettingService.widgetMobile();
	private adjustSlide(): void {
		this.showMinimize = AppSettingService.widgetMobile();
	}

	@HostListener('window:resize', ['$event']) onResize(e: any) {
		this.adjustSlide();
		this.populateData(null);
	}

	close(e: any): void {
		this.dialogRef.close();
	}

	go(objectId: string): void {
		if (this.normalizedData.tCardType === ETerritoryCardType.FieldsOfStudy) {
			if (objectId === "") {
				Swal.fire("", "We are still gathering information about this degree!", "info");
			}
			else {
				this.router.navigateByUrl("College/LearnMore/" + objectId);
			}
		}
		else {
			if (objectId === "") {
				Swal.fire("", "We are still gathering information about this object!", "info");
			}
			else {
				if (this.targetType === 'journey') {
					window.location.href = (AppSettingService.baseUrl + "/Map?ObjectID=" + encodeURIComponent(objectId) + "&IsJourneyable=true");
				}
				else if (this.targetType === 'map') {
					window.location.href = (AppSettingService.baseUrl + "/Map?ObjectID=" + encodeURIComponent(objectId));
				}
				else {
					// go to map learn more
					this.tcs.go(objectId);
				}
			}
		}
		this.close(null);
	}

	select(type: string, objectId: string) {
		if (type === 'cluster') {
			this.populateData(objectId);
		}
		else {
			this.go(this.gatherInstances(objectId)[0].Id);
		}
	};

	back2Cluster(): any {
		this.populateData(null);
	}

	private gatherClusters(): any {
		var objects = [];
		for (var i = 0; i < this.normalizedData.ObjectInstances.length; i++) {
			if (objects.filter((x) => { return x.Id === this.normalizedData.ObjectInstances[i].ClusterId; }).length === 0) {
				objects.push(
					{
						Type: 'cluster',
						Id: this.normalizedData.ObjectInstances[i].ClusterId,
						Name: this.normalizedData.ObjectInstances[i].ClusterName,
						Description: this.normalizedData.ObjectInstances[i].ClusterDescription,
						HeroImage: this.normalizedData.ObjectInstances[i].ClusterHeroImage
					}
				);
			}
		}
		return objects;
	}

	private gatherPathways(clusterId: string): any {
		var objects = [];
		for (var i = 0; i < this.normalizedData.ObjectInstances.length; i++) {
			if (this.normalizedData.ObjectInstances[i].ClusterId === clusterId) {
				if (objects.filter((x) => { return x.Id === this.normalizedData.ObjectInstances[i].PathwayId; }).length === 0) {
					objects.push(
						{
							Type: 'pathway',
							Id: this.normalizedData.ObjectInstances[i].PathwayId,
							Name: this.normalizedData.ObjectInstances[i].PathwayName,
							Description: this.normalizedData.ObjectInstances[i].PathwayDescription,
							MapObjectId: this.normalizedData.ObjectInstances[i].MapObjectId,
							HeroImage: this.normalizedData.ObjectInstances[i].PathwayHeroImage,
							NumberOfGraduation: this.normalizedData.ObjectInstances[i].NumberOfGraduation ?? null,
							CIPCode: this.normalizedData.ObjectInstances[i].CIPCode ?? null,
							MedianTotalDebt: this.normalizedData.ObjectInstances[i].MedianTotalDebt ?? null,
							MedianEarnings: this.normalizedData.ObjectInstances[i].MedianEarnings ?? null,
							MonthlyLoanPayment: this.normalizedData.ObjectInstances[i].MonthlyLoanPayment ?? null,
							MonthlyEarnings: this.normalizedData.ObjectInstances[i].MonthlyEarnings ?? null
						}
					);
				}
			}
		}
		return objects;
	}

	private gatherInstances(pathwayId: string): any {
		var objects = [];
		for (var i = 0; i < this.normalizedData.ObjectInstances.length; i++) {
			if (this.normalizedData.ObjectInstances[i].PathwayId === pathwayId) {
				objects.push(
					{
						Type: 'instance',
						Id: this.normalizedData.ObjectInstances[i].MapObjectId
					}
				);
			}
		}
		return objects;
	}

	@ViewChild('myCarousel') myCarousel: NgbCarousel;
	@ViewChild("outlet", { read: ViewContainerRef }) outletRef: ViewContainerRef;
	@ViewChild("content", { read: TemplateRef }) contentRef: TemplateRef<any>;

	private populateData(clusterId: string) {
		this.outletRef.clear();
		this.pages = [];
		let objects = [];
		if (clusterId != null) {
			objects = this.gatherPathways(clusterId);
			if (objects.length === 1) {
				this.go(this.gatherInstances(objects[0].Id)[0].Id);
				return;
			}
			else if(!this.oneCluster) {
				this.showBack = true;
			}
		}
		else {
			this.showBack = false;
			objects = this.gatherClusters();
			if (objects.length === 1) {
				this.populateData(objects[0].Id);
				return;
			}
		}

		let pageitems = [];
		if (objects.length > 1) {
			objects = objects.sort((x: any, y: any) => x.Name < y.Name ? -1 : x.Name > y.Name ? 1 : 0);
		}
		for (var i = 0; i < objects.length; i++) {
			if (i !== 0 && i % 3 === 0 && pageitems.length > 0) {
				this.pages.push(pageitems);
				pageitems = [];
			}
			if (this.normalizedData.tCardType === ETerritoryCardType.FieldsOfStudy) {
				pageitems.push(this.tcs.normalizeCSCDegree(objects[i]));
			}
			else {
				pageitems.push(objects[i]);
			}
		}
		if (pageitems.length > 0) {
			this.pages.push(pageitems);
		}
		this.outletRef.createEmbeddedView(this.contentRef);
	}

	//#region close back card
	// under mobile view, close the back card on others in same slide when other card display the back card
	@ViewChildren(TerritoryCardComponent) private tCards: QueryList<TerritoryCardComponent>;
	closeBackCard: number = 0;
	showBackCard(card: ITerritoryCard): void {
		if (this.showMinimize === false || this.normalizedData.tCardType !== this.tCardType.FieldsOfStudy) {
			return;
		}
		let fCard = this.tCards.find((x: any) => x.normalizedData.objId === card.objId);
		if (fCard == null) {
			return;
		}
		for (let i = 0; i < this.pages.length; i++) {
			let s = this.pages[i].find((x: any) => x.objId === card.objId);
			if (s != null) {
				for (let j = 0; j < this.pages[i].length; j++) {
					if (this.pages[i][j].objId !== card.objId) {
						let x = this.tCards.find((x: any) => x.normalizedData.objId === this.pages[i][j].objId);
						if (x) {
							x.closeBackCard();
						}
					}
				}
			}
		}
	}
	//#endregion close back card

	ngAfterViewInit(): void {
		if (this.normalizedData.tCardType === ETerritoryCardType.Career) {
			this.ancestorIconBackground = this.tcs.getColors(this.normalizedData.tCardType).backgroundColor;
			this.ancestorIconForeground = this.tcs.getColors(this.normalizedData.tCardType).foregroundColor;
		}
		this.outletRef.createEmbeddedView(this.contentRef);

		//if we have one cluster only, then show pathway
		this.adjustSlide();
		let cs = [...new Set(this.normalizedData.ObjectInstances.map((x: any) => x.ClusterId))];
		if (cs.length > 1) {
			this.populateData(null);
		}
		else {
			this.oneCluster = true;
			this.populateData(cs[0].toString());
		}
	}
}

